export default "__VITE_ASSET__4682aaed__"